import {ACTIONS} from "../reducers/contextMenusReducer";

export function showContextMenu(id) {
  return {type: ACTIONS.SHOW_CONTEXT_MENU, id};
}

export function hideContextMenu(id) {
  return {type: ACTIONS.HIDE_CONTEXT_MENU, id};
}
